import React from 'react';
import PropTypes from 'prop-types';

import ContextMenu from './contextMenu/context-menu';
import {
    MenuOrga,
    SideMenuEvent,
    SideMenuPartner,
    SideMenuTicketOffices,
    SideMenuCharts,
    SideMenuWebservices,
    SideMenuModeration,
    SideMenuPersonalSpace,
    SideMenuOnlineTicketing
} from '../routing/sidebarMenu';

export default function SideBarMenu({ organization, event, partner, chart, ticket_office, syncTicketOffice, webservice, moderationFlowId, personal_space, online_ticketing }) {
    let menus = null;

    // We have no organization, no need to show menu
    if (!organization) {
        return null;
    }

    // We are in organization mode
    if (!event && !partner && !ticket_office && !chart && !webservice && !personal_space && !online_ticketing) {
        menus = <MenuOrga organization={organization} />;
    } else if (!ticket_office && !partner) {
        menus = <SideMenuEvent organizationId={organization.id} event={event} />;
    }
    //We are in partner mode
    if (partner) {
        menus = <SideMenuPartner organizationId={organization.id} partnerId={partner.pk} />;
    }
    // We are in ticket office mode
    if (ticket_office) {
        menus = <SideMenuTicketOffices organizationId={organization.id} ticket_office={ticket_office} />;
    }

    if (chart) {
        menus = <SideMenuCharts organizationId={organization.id} chart={chart} />;
    }

    if (webservice) {
        menus = <SideMenuWebservices organizationId={organization.id} webservice={webservice} />;
    }

    if (moderationFlowId) {
        menus = <SideMenuModeration organizationId={organization.id} />;
    }

    if (personal_space) {
        menus = <SideMenuPersonalSpace organizationId={organization.id} personal_space={personal_space} />;
    }

    if (online_ticketing) {
        menus = <SideMenuOnlineTicketing organizationId={organization.id} online_ticketing={online_ticketing} />;
    }

    return (
        <React.Fragment>
            <ContextMenu
                organization={organization}
                chart={chart}
                webservice={webservice}
                partner={partner}
                event={event}
                ticket_office={ticket_office}
                syncTicketOffice={syncTicketOffice}
                moderationFlowId={moderationFlowId}
                personal_space={personal_space}
                online_ticketing={online_ticketing}
            />
            {menus}
        </React.Fragment>
    );
}

SideBarMenu.propTypes = {
    organization: PropTypes.object,
    event: PropTypes.object,
    partner: PropTypes.object,
    ticket_office: PropTypes.object
};
